import { useTitle } from "libs/useTitle";
import React from "react";
import { contentDE } from "./contentDE";
import { useSelector } from "react-redux";
import { userSelectors } from "features/userSlice";
import { contentFR } from "./contentFR";
import { contentIT } from "./contentIT";


export const TermsOfUsePage = () => {
    const language = useSelector(userSelectors.language);
    const title = {
        'de': 'Nutzungsbedingungen',
        'fr': "Conditions d'utilisation",
        'it': 'Termini di utilizzo'
    }
    const content = {
        'de': contentDE,
        'fr': contentFR,
        'it': contentIT,
    }

    useTitle(title[language]);

    return <>
        <div className="container-fluid policy-page">
            {content[language]}
        </div>
    </>
}
